<template>
    <svg
        height="24px"
        width="24px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 544 512"
        style="fill: currentColor"
    >
        <!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.!-->
        <path
            d="M527.8 288H290.5l158 158c6 6 16 6.5 22.2 .7 38.7-36.5 65.3-85.6 73.1-140.9 1.3-9.5-6.5-17.9-16.1-17.9zm-15.8-64.8C503.7 103.7 408.3 8.3 288.8 0 279.7-.6 272 7.1 272 16.2V240h223.8c9.1 0 16.8-7.7 16.2-16.8zM224 288V50.7c0-9.6-8.4-17.4-17.8-16.1C87 51.5-4.1 155.6 .1 280.4 4.5 408.5 114.8 513.6 243 512c50.4-.6 97-16.9 135.3-44 7.9-5.6 8.4-17.2 1.6-24.1L224 288z"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
    name: "fa-chart-pie",
});
</script>
